module.exports = __webpack_public_path__ + "ae71fa0f36068eced9a10e6cd44a64bb.png";